"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInfoBlockGroupProperty = exports.infoBlockGroupPropertyDefinition = void 0;
exports.infoBlockGroupPropertyDefinition = {
    view: { label: 'Info block group' },
    constraints: [
        {
            name: 'orderedProperties',
            argument: ['info-block-group-title', 'info-block-group-info-blocks'],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'info-block-group',
};
const isInfoBlockGroupProperty = (prop) => {
    return prop.name === exports.infoBlockGroupPropertyDefinition.name;
};
exports.isInfoBlockGroupProperty = isInfoBlockGroupProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5mby1ibG9jay1ncm91cC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2luZm8tYmxvY2stZ3JvdXAucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxnQ0FBZ0MsR0FBRztJQUM5QyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsa0JBQWtCLEVBQUU7SUFDbkMsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsbUJBQW1CO1lBQ3pCLFFBQVEsRUFBRSxDQUFDLHdCQUF3QixFQUFFLDhCQUE4QixDQUFDO1NBQ3JFO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsbUJBQW1CO0lBQ3pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLGtCQUFrQjtDQUNPLENBQUE7QUFJMUIsTUFBTSx3QkFBd0IsR0FBRyxDQUFDLElBQWtCLEVBQWtDLEVBQUU7SUFDN0YsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHdDQUFnQyxDQUFDLElBQUksQ0FBQTtBQUM1RCxDQUFDLENBQUE7QUFGWSxRQUFBLHdCQUF3Qiw0QkFFcEMifQ==